import { Link } from "react-router-dom";

import Stack from "react-bootstrap/Stack";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

import {
  formatCurrency,
  formatNumber,
  formatDateTime,
  getTimezoneDate,
  getSinglarOrPluralWord,
  timezones,
  globalStatuses,
} from "../../../../utilities/helpers";

import { TrashButton } from "../../../TrashButton";

import placeholder from "../../../../assets/placeholder.png";

export default function Package({ eventPackage, openDeleteModal }) {
  const timezone = timezones(eventPackage?.venue?.timezone);

  const getStatus = (s) => {
    let status = s;
    // if unpublished
    if (eventPackage?.status === "unpublished") {
      status = "draft";
    }
    // if is hidden and has not ended
    if (!eventPackage?.isVisible && eventPackage?.status !== "complete") {
      status = "hidden";
    }
    // if sold out and has not ended
    else if (eventPackage?.soldout && eventPackage?.status !== "complete") {
      status = "sold_out";
    }
    return globalStatuses[status];
  };

  return (
    <Card className="card--sm">
      <Card.Body className="flex gap-3">
        <Link to={`/package/${eventPackage?.uuid}`} className="flex-grow-1">
          <Stack direction="horizontal" gap={3}>
            <Card.Img
              src={eventPackage?.image?.url || placeholder}
              width="80"
              height="80"
              className="event-image card-img-sm"
              alt={`Cover art for ${eventPackage?.name} package`}
            />
            <Stack className="justify-content-around">
              <Card.Title as="h5">{eventPackage?.name}</Card.Title>
              <Card.Subtitle
                as="h6"
                className="m-0 subtitle-bolder subtitle--dark"
              >
                {eventPackage?.organization?.name} -{" "}
                {eventPackage?.season?.name}
              </Card.Subtitle>
              <Card.Text className="text-muted small">
                <span>
                  <span>
                    {formatDateTime(
                      getTimezoneDate(eventPackage.start, timezone),
                      "dateOnly",
                    )}
                  </span>
                  <span className="time">
                    {formatDateTime(
                      getTimezoneDate(eventPackage.start, timezone),
                      "timeOnly",
                    )}
                  </span>
                </span>
                <span className="to">
                  <span>
                    {formatDateTime(
                      getTimezoneDate(eventPackage?.end, timezone),
                      "dateOnly",
                    )}
                  </span>
                  <span className="time">
                    {formatDateTime(
                      getTimezoneDate(eventPackage?.end, timezone),
                      "timeOnly",
                    )}
                  </span>
                </span>
              </Card.Text>
            </Stack>
          </Stack>
        </Link>
        <Stack direction="horizontal" gap={3} className="ms-auto">
          <Badge bg="none" className="badge-label">
            {formatCurrency(eventPackage?.price)}
          </Badge>
          <Badge bg="none" className="badge-label">
            {formatNumber(eventPackage?.events?.length)}{" "}
            {getSinglarOrPluralWord(eventPackage?.events?.length, "Event")}
          </Badge>
          <Badge
            bg="none"
            className={`badge--${getStatus(eventPackage?.status)?.type}`}
          >
            {getStatus(eventPackage?.status)?.label}
          </Badge>
          <TrashButton
            variant="danger"
            onClick={(e) => openDeleteModal(e, eventPackage?.id)}
            isDisabled={eventPackage?.isSold}
          />
        </Stack>
      </Card.Body>
    </Card>
  );
}
